import classes from "./NoData.module.scss";

const NoData = (props)=> {
    return <span className={`${props.className} ${classes["no-data"]}`}>NO DATA</span>
}

export default NoData